import API from "./api";

export const createCDNFromStrapi = (obj) => {
  if (!obj || !obj.hash || !obj.ext) {
    return "";
  }

  return `${API.CDN}${obj.hash}${obj.ext}`;
};

export default createCDNFromStrapi;
